"use client";

import { LoadingIcon } from "@components/icons/loading";
import { useLocalStore } from "@store/useLocalStore";

export function ClientProvider({ children }) {

    const userRole = useLocalStore((state) => state.user.role);

    return (
        userRole === "client" ? children : <LoadingIcon />
    )
}
